import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import toast from 'react-hot-toast';

interface CorporateManagerRouteProps {
  children: React.ReactNode;
}

const CorporateManagerRoute: React.FC<CorporateManagerRouteProps> = ({ children }) => {
  const { user, loading, isCorporateManager, isAdminViewingCorporate } = useUser();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isCorporateManager && !isAdminViewingCorporate) {
    toast.error('Manager access required');
    return <Navigate to="/corporate-dashboard" replace />;
  }

  return <>{children}</>;
};

export default CorporateManagerRoute;


